(() => {
  if (window.wlyBagFinderReady) return;
  window.wlyBagFinderReady = true;
  const wlyFormatMoney = (wlyCents, wlyFormat) => {
    const wlyPattern = /\{\{\s*(\w+)\s*\}\}/;
    const wlyTemplate = (wlyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const wlyGroup = (wlyNumber, wlyDecimals, wlyThousands, wlyDecimal) => {
      const wlyFixed = (wlyNumber / 100).toFixed(wlyDecimals).split('.');
      const wlyWhole = wlyFixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, wlyThousands);
      return wlyFixed[1] ? `${wlyWhole}${wlyDecimal}${wlyFixed[1]}` : wlyWhole;
    };
    const wlyMatch = wlyTemplate.match(wlyPattern);
    const wlyKey = wlyMatch ? wlyMatch[1] : 'amount';
    const wlyValue = {
      amount: () => wlyGroup(wlyCents, 2, ',', '.'),
      amount_no_decimals: () => wlyGroup(wlyCents, 0, ',', '.'),
      amount_with_comma_separator: () => wlyGroup(wlyCents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => wlyGroup(wlyCents, 0, '.', ','),
      amount_with_apostrophe_separator: () => wlyGroup(wlyCents, 2, "'", '.'),
      amount_with_space_separator: () => wlyGroup(wlyCents, 2, ' ', ','),
    }[wlyKey] || (() => wlyGroup(wlyCents, 2, ',', '.'));
    return wlyTemplate.replace(wlyPattern, wlyValue());
  };
  const wlyParsePacks = (wlyText) => (wlyText || '')
    .split('|')
    .filter(Boolean)
    .map((wlyEntry) => {
      const [wlyCount, wlyId, wlyPrice, wlyAvailable] = wlyEntry.split('~');
      return {
        count: parseInt(wlyCount, 10) - 100000,
        id: wlyId,
        price: parseInt(wlyPrice, 10),
        available: wlyAvailable === '1',
      };
    })
    .filter((wlyPack) => wlyPack.count > 0 && wlyPack.id);
  const wlyInit = (wlyRoot) => {
    if (wlyRoot.dataset.wlyFinderReady) return;
    const wlyDataEl = wlyRoot.querySelector('[data-wly-finder-data]');
    if (!wlyDataEl) return;
    let wlyData;
    try {
      wlyData = JSON.parse(wlyDataEl.textContent);
    } catch (wlyErr) {
      return;
    }
    wlyRoot.dataset.wlyFinderReady = 'true';
    const wlyGet = (wlySelector) => wlyRoot.querySelector(wlySelector);
    const wlyRange = wlyGet('[data-wly-finder-lbs]');
    const wlyRangeText = wlyGet('[data-wly-finder-lbs-text]');
    const wlyName = wlyGet('[data-wly-finder-name]');
    const wlyImage = wlyGet('[data-wly-finder-image]');
    const wlyPack = wlyGet('[data-wly-finder-pack]');
    const wlyBags = wlyGet('[data-wly-finder-bags]');
    const wlyCc = wlyGet('[data-wly-finder-cc]');
    const wlyNote = wlyGet('[data-wly-finder-note]');
    const wlyVariant = wlyGet('[data-wly-finder-variant]');
    const wlyQty = wlyGet('[data-wly-finder-qty]');
    const wlyButton = wlyGet('[data-wly-finder-button]');
    const wlyFill = (wlyTemplate, wlyValues) => Object.keys(wlyValues).reduce((wlyText, wlyKey) => wlyText.split(`[${wlyKey}]`).join(wlyValues[wlyKey]), wlyTemplate || '');
    const wlyUpdate = () => {
      const wlyFoodInput = wlyRoot.querySelector('[data-wly-finder-food]:checked');
      const wlyStoreInput = wlyRoot.querySelector('[data-wly-finder-store]:checked');
      const wlyFood = wlyFoodInput && wlyData.foods[wlyFoodInput.value];
      if (!wlyFood) return;
      const wlyLbs = wlyRange ? Number(wlyRange.value) : 50;
      const wlyUseBucket = wlyStoreInput && wlyStoreInput.value === 'bucket' && !wlyFood.skipBucket;
      const wlyConfig = wlyUseBucket ? wlyFood.bucket : wlyFood.pantry;
      const wlyCap = Number(wlyFood.cap) * (wlyUseBucket ? Number(wlyData.bucketRatio) || 1 : 1);
      const wlyBagCount = Math.max(1, Math.ceil(wlyLbs / (wlyCap || 1)));
      const wlyPacks = wlyParsePacks(wlyConfig.packs);
      const wlyAvailable = wlyPacks.filter((wlyItem) => wlyItem.available);
      const wlyFit = wlyAvailable.find((wlyItem) => wlyItem.count >= wlyBagCount);
      const wlyChoice = wlyFit || wlyAvailable[wlyAvailable.length - 1];
      const wlyPacksNeeded = wlyChoice && !wlyFit ? Math.ceil(wlyBagCount / wlyChoice.count) : 1;
      const wlyLbsLabel = `${wlyLbs} ${wlyData.unit}`;
      if (wlyRangeText) wlyRangeText.textContent = wlyLbsLabel;
      if (wlyRange) wlyRange.setAttribute('aria-valuetext', wlyLbsLabel);
      if (wlyName) {
        wlyName.textContent = wlyConfig.title;
        if (wlyConfig.url) wlyName.href = wlyConfig.url;
      }
      if (wlyImage && wlyConfig.image) {
        let wlyImg = wlyImage.querySelector('img');
        if (!wlyImg) {
          wlyImage.innerHTML = '';
          wlyImg = document.createElement('img');
          wlyImg.alt = '';
          wlyImg.loading = 'lazy';
          wlyImage.appendChild(wlyImg);
        }
        wlyImg.removeAttribute('srcset');
        wlyImg.removeAttribute('sizes');
        wlyImg.src = wlyConfig.image;
      }
      if (wlyBags) wlyBags.textContent = `${wlyData.bagsPrefix || ''}${wlyBagCount}`;
      if (wlyCc) wlyCc.textContent = wlyConfig.cc || '';
      if (wlyNote) wlyNote.innerHTML = wlyConfig.note || '';
      if (!wlyChoice) {
        if (wlyPack) wlyPack.textContent = '';
        if (wlyButton) {
          wlyButton.textContent = wlyData.soldOut;
          wlyButton.disabled = true;
        }
        return;
      }
      const wlyTotal = wlyFormatMoney(wlyChoice.price * wlyPacksNeeded, wlyData.moneyFormat);
      const wlyValues = { qty: wlyPacksNeeded, count: wlyChoice.count, price: wlyTotal };
      if (wlyPack) wlyPack.textContent = wlyFill(wlyPacksNeeded > 1 ? wlyData.packMulti : wlyData.packSingle, wlyValues);
      if (wlyVariant) wlyVariant.value = wlyChoice.id;
      if (wlyQty) wlyQty.value = wlyPacksNeeded;
      if (wlyButton) {
        wlyButton.textContent = wlyFill(wlyPacksNeeded > 1 ? wlyData.buttonMulti : wlyData.buttonSingle, wlyValues);
        wlyButton.disabled = false;
      }
    };
    wlyRoot.addEventListener('change', (event) => {
      if (event.target.matches('[data-wly-finder-food], [data-wly-finder-store], [data-wly-finder-lbs]')) wlyUpdate();
    });
    if (wlyRange) wlyRange.addEventListener('input', wlyUpdate);
    wlyUpdate();
  };
  const wlyBoot = () => document.querySelectorAll('[data-wly-finder]').forEach(wlyInit);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wlyBoot);
  } else {
    wlyBoot();
  }
  document.addEventListener('shopify:section:load', wlyBoot);
})();
